export const CLASS_BLOCK_NAME = 'bb-icon';
export const SIZE_10x10 = 'size-10x10';
export const SIZE_12x12 = 'size-12x12';
export const SIZE_18x18 = 'size-18x18';
export const SIZE_30x30 = 'size-30x30';
export const SIZE_24x24 = 'size-24x24';
export const SIZE_28x28 = 'size-28x28';
export const SIZE_36x36 = 'size-36x36';

export const WIDTH_12 = 'width-12';
export const WIDTH_15 = 'width-15';

export const ROTATE_180 = 'rotate-180';

export const ICON_ORANGE_DROPDOWN = 'orange-dropdown';
export const ICON_BRAND_DEFAULT_RIGHT_ARROW = 'right-arrow-orange';
export const ICON_EVENT_SCHEDULE = 'event-schedule';
export const ICON_EVENT_SCHEDULE_INVERTED = 'event-schedule-inverted';
export const ICON_VIRTUAL_SPORTS = 'virtual-sports';
export const ICON_VIRTUAL_SPORTS_INVERTED = 'virtual-sports-inverted';
export const ICON_NO_RESULTS = 'no-results';
